function pad(n) {
	return n < 10 ? '0' + n : n
}

site.skolaskjar = {
	refreshRateInMinutes: 10,
	autoplayTimeoutInSeconds: 7,

	init: function () {
		if (!$('body').hasClass('skolaskjar')) return false;

		$('html').css('height', '100%');

		site.owl.init('#custom-slider > .items', {
			loop: true,
			dots: false,
			autoplay: true,
			autoplayTimeout: site.skolaskjar.autoplayTimeoutInSeconds * 1000,
			smartSpeed: 500,
			items: 1,
			nav: true,
			navText : ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"]
		});

		site.skolaskjar.getDate();

		var min = 1000 * 60;

		//Refresh date / time
		setInterval(function () {
			site.skolaskjar.getDate();
		}, min);

		setInterval(function () {
			site.skolaskjar.checker();
		}, site.skolaskjar.refreshRateInMinutes * min)
	},

	getDate: function () {
		var date = new Date(),
			time = pad(date.getHours()) + ':' + pad(date.getMinutes()),
			weekdays = ['sunnudagur', 'mánudagur', 'þriðjudagur', 'miðvikudagur', 'fimmtudagur', 'föstudagur', 'laugardagur'],
			monthNames = ["janúar", "febrúar", "mars", "apríl", "maí", "júní", "júlí", "ágúst", "september", "október", "nóvember", "desember"],
			r = weekdays[date.getDay()] + ' ' + date.getDate() + '. ' + monthNames[date.getMonth()] + ' ' + date.getFullYear() + ' - ' + time;

		$('#footer').html(r);
	},

	checker: function () {

		$.ajax({
			url: '/_/moya/adverts/region/show/2',
			success: function (r) {
				if (parseInt(r.replace( /\D+/g, '')) > $('#custom-slider .items').data('timestamp')) {
					site.skolaskjar.refresh();
				}
			}
		});
	},

	refresh: function () {
		location.reload();
	}
};

site.inits.push('site.skolaskjar.init()');
